import styled from "styled-components";
import { Typography } from "antd";
import colors from "constants/colors";

const { Text } = Typography;

export const StyledText = styled(Text)`
  font-size: 1.1em;
`;

export const StyledList = styled.ul`
  list-style-type: none;
`;

export const StyledItem = styled.li`
  font-size: 1.1em;
  margin-top: 5px;
  ::before {
    content: "\\25FC";
    color: ${colors.primary};
    font-weight: bolder;
    font-size: 1.1em;
    display: inline-block;
    width: 1.5em;
    margin-left: -1.5em;
  }
`;
